import * as actionTypes from "../constants/PaymentPlanActionTypes";

const initialState = {
  orderId: null,

  createdAt: null,

  products: [],

  coupon: null,

  installments: [],

  totalPrice: 0,

  owing: 0,
};

const paymentPlanReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case actionTypes.SET_PAYMENT_PLAN:
    const { _id, items, couponCode, totalPrice, installments, owing, createdAt } = payload;
    return { ...state, products: items, orderId: _id, totalPrice: totalPrice || 0, owing, coupon: couponCode, installments, createdAt };
  
  case actionTypes.SET_OWING:
    return { ...state, owing: payload };
  
  case actionTypes.SET_INSTALLMENTS:
    return { ...state, installments: payload };

    default:
      return state;
  }
}

export default paymentPlanReducer;